function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "43.07 101.01 409.93 361.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.45,
    y: 369.11,
    width: 83.17,
    height: 83.17,
    transform: "translate(-87.95 68.19) rotate(-13.32)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.61,436.42c-20.23,4.79-48.88,9.29-66.16,11.83-9,1.32-15,2.1-15,2.1-7.66-14-21.48-70.54-21.48-70.54l80.93-19.16c.16.69.3,1.38.45,2.06C289,406.44,300.61,436.42,300.61,436.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3,122l8.2,148.2-3,12.19-4.34-11.78L52.94,122.4a1.86,1.86,0,0,1,1.75-2l3.65-.2A1.86,1.86,0,0,1,60.3,122Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.75,300.46l27.11-177.13a20.78,20.78,0,0,1,23.68-17.39l260.31,39.85a20.77,20.77,0,0,1,17.4,23.67L393.13,346.59A20.76,20.76,0,0,1,369.46,364L109.14,324.14A20.78,20.78,0,0,1,91.75,300.46Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.19,120.43H123.8a1,1,0,0,1,1,1v5.74a0,0,0,0,1,0,0H109.2a0,0,0,0,1,0,0v-5.74A1,1,0,0,1,110.19,120.43Z",
    transform: "translate(-23.07 220.7) rotate(-81.3)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.3,102.66h13.61a1,1,0,0,1,1,1v5.74a0,0,0,0,1,0,0H146.31a0,0,0,0,1,0,0v-5.74A1,1,0,0,1,147.3,102.66Z",
    transform: "translate(17.81 -22.1) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.63,105.46h13.61a1,1,0,0,1,1,1v5.74a0,0,0,0,1,0,0H164.64a0,0,0,0,1,0,0v-5.74A1,1,0,0,1,165.63,105.46Z",
    transform: "translate(18.45 -24.84) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.75,296.46l27.11-177.13a20.78,20.78,0,0,1,23.68-17.39l260.31,39.85a20.77,20.77,0,0,1,17.4,23.67L390.13,342.59A20.76,20.76,0,0,1,366.46,360L106.14,320.14A20.78,20.78,0,0,1,88.75,296.46Z",
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.48,357.79,105.82,317.74a17.76,17.76,0,0,1-14.88-20.25L118.26,119a17.77,17.77,0,0,1,20.25-14.88l261.67,40.05a17.79,17.79,0,0,1,14.88,20.26L387.74,342.91A17.77,17.77,0,0,1,367.48,357.79Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,208.92a1,1,0,1,1-.85-1.16A1,1,0,0,1,109,208.92Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51,218.23a1.95,1.95,0,0,1-3.85-.59,1.95,1.95,0,0,1,3.85.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,195.82a1.95,1.95,0,0,1-3.85-.59,1.95,1.95,0,1,1,3.85.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,224.52a1.42,1.42,0,1,1-1.19-1.62A1.42,1.42,0,0,1,107,224.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.49,161.36,380.56,343.88a8.78,8.78,0,0,1-10,7.35L151.35,317.68,146.6,317l-17.87-2.74-8.65-1.32L107.58,311l-2.73-.42a8.78,8.78,0,0,1-7.35-10L125.44,118a8.76,8.76,0,0,1,10-7.34l81.83,12.52,12.38,1.9,11.83,1.81,15.2,2.32,5.5.84,139,21.27A8.78,8.78,0,0,1,408.49,161.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203,316l-93-14.23a2.31,2.31,0,0,1-1.93-2.63l9.23-60.33a2.32,2.32,0,0,1,2.64-1.93l93,14.23a2.3,2.3,0,0,1,1.93,2.63l-9.23,60.33A2.31,2.31,0,0,1,203,316Zm-83.15-78.32a1.5,1.5,0,0,0-1.71,1.26l-9.23,60.32a1.5,1.5,0,0,0,1.26,1.71l92.95,14.23a1.5,1.5,0,0,0,1.71-1.26l9.24-60.32a1.52,1.52,0,0,0-1.26-1.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.9,274.19,168.72,286a24.58,24.58,0,0,0-1.54-26Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,273l18.6-13.67a24.54,24.54,0,0,0-9.63-7.61l-3.67,8.7Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27,250l-3.22,21,8.28-19.63A24.73,24.73,0,0,0,151.27,250Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,273.94l3.67-24a24.55,24.55,0,0,0-26.29,33Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,298.5a24.57,24.57,0,0,0,24.88-11.81l-21.19-12-22.66,8.95A24.55,24.55,0,0,0,143.44,298.5Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.04,
    y: 259.52,
    width: 4.05,
    height: 4.05,
    rx: 0.63,
    transform: "translate(41.69 -24.84) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,263.55,188.7,261.7a.46.46,0,0,1-.39-.53.46.46,0,0,1,.53-.39l12,1.85a.46.46,0,0,1,.39.53A.48.48,0,0,1,200.75,263.55Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.76,265l-8.37-1.28a.46.46,0,0,1-.39-.53.47.47,0,0,1,.53-.39l8.37,1.28a.46.46,0,0,1,.39.53A.46.46,0,0,1,196.76,265Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.67,
    y: 268.48,
    width: 4.05,
    height: 4.05,
    rx: 0.63,
    transform: "translate(43.03 -24.53) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.38,272.5l-12.06-1.84a.48.48,0,0,1-.39-.53.47.47,0,0,1,.53-.39l12.06,1.85a.46.46,0,1,1-.14.91Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.39,273.94,187,272.66a.47.47,0,0,1,.14-.92l8.37,1.28a.46.46,0,0,1,.39.53A.46.46,0,0,1,195.39,273.94Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.3,
    y: 277.44,
    width: 4.05,
    height: 4.05,
    rx: 0.63,
    transform: "matrix(0.99, 0.15, -0.15, 0.99, 44.37, -24.22)",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,281.46,186,279.62a.47.47,0,0,1,.14-.92l12,1.84a.46.46,0,0,1,.39.53A.46.46,0,0,1,198,281.46Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,282.9l-8.37-1.28a.47.47,0,0,1,.14-.92l8.37,1.28a.47.47,0,0,1-.14.92Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.93,
    y: 286.4,
    width: 4.05,
    height: 4.05,
    rx: 0.63,
    transform: "translate(45.71 -23.91) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.63,290.42l-12-1.84a.47.47,0,0,1-.39-.53.46.46,0,0,1,.53-.39l12.05,1.84a.46.46,0,0,1,.39.53A.46.46,0,0,1,196.63,290.42Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.65,291.86l-8.37-1.28a.46.46,0,0,1-.39-.53.46.46,0,0,1,.53-.39l8.37,1.28a.47.47,0,0,1,.39.53A.46.46,0,0,1,192.65,291.86Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.56,
    y: 295.36,
    width: 4.05,
    height: 4.05,
    rx: 0.63,
    transform: "translate(47.05 -23.59) rotate(8.7)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,299.38l-12-1.84a.47.47,0,0,1-.39-.53.46.46,0,0,1,.53-.39l12.05,1.84a.46.46,0,0,1,.39.53A.46.46,0,0,1,195.26,299.38Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.28,300.82l-8.38-1.28a.46.46,0,0,1-.38-.53.45.45,0,0,1,.53-.39l8.37,1.28a.47.47,0,1,1-.14.92Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.16,276.38,227,253.25a2.32,2.32,0,0,0-2.64,1.93l-.64,4.16-.12.8-.86,5.61-.12.8-.86,5.6-.12.79-.86,5.61-.12.79-.86,5.61-.12.8-.86,5.6-.12.8-.86,5.6-.12.8-.86,5.6-.12.8-.86,5.6-.12.8-.63,4.16a2.31,2.31,0,0,0,1.93,2.64l151.13,23.13a2.31,2.31,0,0,0,2.62-1.94l.64-4.16.12-.8.86-5.6.12-.8.86-5.61.12-.79.86-5.6.12-.8.86-5.6.12-.8.86-5.61.12-.79.86-5.61.12-.79.86-5.6.12-.8.86-5.61.12-.8.64-4.16A2.31,2.31,0,0,0,378.16,276.38Zm-8.1,62.84a1.51,1.51,0,0,1-1.71,1.26L217.23,317.35a1.52,1.52,0,0,1-1.27-1.72l.64-4.16,154.09,23.59Zm.76-5-154.1-23.58.86-5.61,154.09,23.59Zm1-6.4L217.7,304.28l.86-5.61,154.09,23.58Zm1-6.4-154.1-23.59.86-5.6,154.09,23.58Zm1-6.4-154.1-23.59.86-5.6,154.09,23.59Zm1-6.4-154.1-23.59.86-5.61,154.09,23.59Zm1-6.41-154.1-23.58.86-5.6,154.09,23.58Zm1-6.4L222.6,272.27l.86-5.6,154.09,23.58Zm1-6.39L223.58,265.87l.86-5.61,154.09,23.59Zm-153.11-30,.64-4.15a1.5,1.5,0,0,1,1.71-1.26L378,277.18a1.5,1.5,0,0,1,1.25,1.71l-.64,4.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.3,168.72,136.78,129.3a2.63,2.63,0,0,0-3,2.21l-14.43,94.27a2.64,2.64,0,0,0,2.2,3L379.08,268.2a2.64,2.64,0,0,0,3-2.2l14.43-94.28A2.63,2.63,0,0,0,394.3,168.72Zm-210,13.55L202.18,185l-1.56,10.16-17.91-2.74Zm-2.35,10L164,189.58l1.56-10.17,17.91,2.74ZM203,185.14l17.92,2.74-1.56,10.17-17.91-2.74Zm92.88,13.4-17.91-2.74,1.55-10.17,17.92,2.74Zm2.35-10,17.92,2.74-1.56,10.17-17.91-2.74Zm-57.81,2.38,17.92,2.74-1.56,10.17L238.84,201Zm-2.35,10-17.91-2.74L221.68,188l17.92,2.74Zm21.06-7.18L277,196.47l-1.56,10.17-17.91-2.74Zm18.71,2.86,17.92,2.74-1.56,10.17-17.91-2.74Zm-.67-.92-17.91-2.74,1.55-10.17,17.92,2.75Zm-18.71-2.86-17.91-2.74,1.55-10.17L260,182.64ZM239.72,190l-17.91-2.75L223.36,177l17.92,2.74ZM221,187.08l-17.91-2.74,1.55-10.17,17.92,2.74Zm-1.8,11.77L217.65,209l-17.91-2.74,1.56-10.17Zm.8.12,17.91,2.74-1.56,10.17-17.91-2.74Zm18.71,2.86,17.91,2.74-1.56,10.17L237.16,212Zm18.71,2.86,17.91,2.75-1.56,10.16-17.91-2.74Zm18.71,2.87,17.91,2.74-1.56,10.17-17.91-2.74Zm18.71,2.86,17.91,2.74-1.56,10.17-17.91-2.74Zm.12-.79,1.55-10.17,17.92,2.74-1.56,10.17Zm20.26-7.31,17.92,2.74-1.56,10.17-17.91-2.74Zm18.71,2.86,17.92,2.75-1.56,10.16-17.91-2.74Zm.13-.79,1.55-10.17L353.54,197,352,207.13Zm-.8-.12-17.91-2.75,1.55-10.17,17.92,2.75ZM317,190.56l1.56-10.17,17.91,2.74L335,193.3Zm-.79-.12-17.91-2.75,1.55-10.16,17.91,2.74Zm-18.71-2.87-17.92-2.74,1.56-10.17,17.91,2.74Zm-18.71-2.86L260.9,182l1.56-10.17,17.91,2.74Zm-18.71-2.87L242.2,179.1l1.55-10.17,17.91,2.75ZM241.4,179l-17.91-2.74L225,166.07,243,168.81Zm-18.71-2.86-17.92-2.74,1.56-10.17L224.24,166ZM204,173.25l-17.91-2.74,1.55-10.17,17.91,2.75Zm-.12.8-1.56,10.17-17.91-2.74,1.55-10.17Zm-20.27,7.31-17.91-2.75,1.55-10.17,17.92,2.75Zm-18.71-2.87L147,175.75l1.55-10.17,17.92,2.74Zm-.12.8-1.56,10.17-17.91-2.74,1.56-10.17Zm-1.68,11-1.56,10.17-17.91-2.74,1.56-10.17Zm.8.13,17.91,2.74-1.56,10.17-17.91-2.75Zm18.71,2.86L200.5,196l-1.56,10.17L181,203.41ZM198.82,207l-1.56,10.17-17.91-2.75,1.56-10.17Zm.8.12,17.91,2.74L216,220l-17.92-2.74Zm18.71,2.86,17.91,2.74-1.56,10.17-17.91-2.74ZM237,212.8,255,215.54l-1.56,10.17L235.48,223Zm18.71,2.86,17.91,2.74-1.56,10.17-17.91-2.74Zm18.71,2.86,17.91,2.75-1.56,10.16-17.91-2.74Zm18.71,2.87,17.91,2.74-1.56,10.17-17.91-2.74Zm18.71,2.86L329.79,227l-1.56,10.17-17.91-2.74Zm.12-.8,1.56-10.16L331.47,216l-1.56,10.17Zm20.27-7.3,17.91,2.74-1.56,10.17-17.91-2.74ZM351,219l17.91,2.74-1.56,10.17-17.91-2.74Zm.12-.79,1.55-10.17,17.92,2.74L369,221Zm1.68-11,1.55-10.17,17.92,2.74L370.69,210Zm1.67-11L356,186.12l17.91,2.74L372.37,199Zm-.79-.13-17.92-2.74,1.56-10.17L355.21,186Zm-16.24-13.7L339,172.29,356.89,175l-1.55,10.17Zm-.79-.13-17.92-2.74,1.56-10.17,17.91,2.75Zm-18.71-2.86L300,176.73l1.56-10.17,17.91,2.74Zm-18.71-2.86-17.92-2.74,1.56-10.17,17.91,2.74Zm-18.71-2.87L262.58,171l1.56-10.17,17.91,2.74Zm-18.71-2.86-17.92-2.74L245.43,158l17.91,2.74ZM243.08,168l-17.92-2.75,1.56-10.16,17.91,2.74Zm-18.71-2.87-17.92-2.74L208,152.24,225.92,155Zm-18.71-2.86-17.92-2.74,1.56-10.17,17.91,2.74ZM187,159.42,169,156.68l1.56-10.17,17.91,2.75Zm-.13.8-1.55,10.17-17.91-2.74,1.55-10.17Zm-20.26,7.31-17.91-2.75,1.55-10.16,17.91,2.74Zm-18.71-2.87-17.91-2.74,1.55-10.17,17.92,2.74Zm-.12.8-1.56,10.17-17.91-2.74,1.55-10.17Zm-1.68,11-1.56,10.17-17.91-2.74,1.56-10.17Zm-1.68,11-1.56,10.17-17.91-2.74,1.56-10.17Zm-1.68,11-1.55,10.16-17.92-2.74,1.56-10.17Zm.8.12,17.91,2.74-1.55,10.17-17.92-2.74Zm18.71,2.86,17.91,2.74-1.56,10.17-17.91-2.74Zm16.23,13.71-1.55,10.17L159,222.48l1.56-10.17Zm.8.12,17.91,2.74-1.55,10.17-17.92-2.74ZM197.94,218l17.91,2.75-1.55,10.16-17.92-2.74Zm18.71,2.87,17.91,2.74L233,233.81l-17.92-2.74Zm18.71,2.86,17.91,2.74-1.55,10.17-17.92-2.74Zm18.71,2.87L272,229.37l-1.55,10.17-17.92-2.75Zm18.71,2.86,17.91,2.74-1.55,10.17-17.92-2.74Zm18.71,2.86,17.91,2.74-1.55,10.17-17.92-2.74Zm18.71,2.87L328.11,238l-1.55,10.17-17.92-2.74Zm18.71,2.86,17.91,2.74L345.27,251l-17.92-2.74Zm.12-.8,1.56-10.17,17.91,2.75L346.94,240ZM349.3,230l17.91,2.74-1.56,10.17-17.91-2.74ZM368,232.84l17.91,2.74-1.56,10.17L366.45,243Zm.12-.79,1.56-10.17,17.91,2.74L386,234.79Zm1.68-11,1.55-10.17,17.92,2.74-1.56,10.17Zm1.68-11L373,200,391,202.69l-1.55,10.17Zm1.67-11L374.72,189l17.91,2.74-1.55,10.17Zm1.68-11L376.4,178l17.91,2.74-1.55,10.17Zm-.79-.12-17.92-2.74,1.56-10.17,17.91,2.74Zm-16.24-13.71,1.56-10.16,17.91,2.74-1.56,10.17Zm-.8-.12-17.91-2.74,1.56-10.17,17.91,2.74Zm-18.71-2.86-17.91-2.74L322,158.46l17.91,2.74Zm-18.71-2.86-17.91-2.75,1.56-10.16,17.91,2.74Zm-18.71-2.87L283,162.9l1.56-10.17,17.91,2.74Zm-18.71-2.86L264.26,160l1.56-10.17,17.91,2.74Zm-18.71-2.87-17.91-2.74L247.11,147,265,149.75Zm-18.7-2.86-17.92-2.74,1.56-10.17,17.91,2.74Zm-18.71-2.86-17.92-2.75,1.56-10.16L227.6,144Zm-18.72-2.87-17.91-2.74L191,138.41l17.91,2.74Zm-18.7-2.86-17.92-2.74,1.56-10.17,17.91,2.74Zm-18.71-2.86L152,142.85l1.56-10.16,17.91,2.74Zm-.13.79-1.55,10.17-17.92-2.74,1.56-10.17Zm-20.26,7.31L131.61,151l1.56-10.17,17.91,2.74ZM123.1,206.58,141,209.32l-1.55,10.17-17.92-2.74Zm18.71,2.86,17.91,2.74-1.55,10.17-17.92-2.74ZM158,223.15l-1.55,10.17-17.91-2.74,1.55-10.17Zm.8.12L176.75,226l-1.55,10.17-17.91-2.74Zm18.71,2.87,17.91,2.74-1.55,10.17L176,236.3ZM196.26,229l17.91,2.74-1.55,10.17-17.92-2.74ZM215,231.86l17.91,2.75-1.55,10.16L213.42,242Zm18.71,2.87,17.91,2.74L250,247.64l-17.91-2.74Zm18.71,2.86,17.91,2.74-1.55,10.17-17.92-2.74Zm18.71,2.86L289,243.2l-1.55,10.16-17.92-2.74Zm18.71,2.87,17.91,2.74-1.55,10.17-17.92-2.74Zm18.71,2.86,17.91,2.74-1.55,10.17L307,256.35Zm18.71,2.87,17.91,2.74L343.59,262l-17.92-2.75Zm18.71,2.86,17.91,2.74-1.55,10.17-17.92-2.74Zm.12-.8,1.56-10.17,17.91,2.75L364,253.85Zm20.27-7.3,17.91,2.74-1.55,10.17L364.77,254Zm29.38-72.21L394.43,180l-17.91-2.74,1.56-10.17,16.1,2.46A1.83,1.83,0,0,1,395.71,171.6Zm-259-41.5,16.1,2.46-1.55,10.17L133.29,140l1.28-8.36A1.83,1.83,0,0,1,136.66,130.1Zm-16.52,95.8,1.28-8.36,17.91,2.75-1.55,10.16L121.67,228A1.84,1.84,0,0,1,120.14,225.9ZM379.2,267.41l-16.11-2.47,1.56-10.17,17.91,2.74-1.28,8.37A1.83,1.83,0,0,1,379.2,267.41Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.8,236.38l-4.52,29.48a1.75,1.75,0,0,1-2,1.47L121.61,227.89a1.75,1.75,0,0,1-1.46-2l.6-3.94s12.11-9.76,19.69-8.6C149.39,214.72,151,219.8,159,221s16.76-17.3,24-16.2c3.91.6,4.91,3.61,6.82,6.37a10.37,10.37,0,0,0,7.4,4.66l.3.05c9.8,1.5,23.06-50.52,36.54-48.46,6,.91,8.37,12.39,10.16,25.07,2.27,16,3.55,34,9.8,34.91,11.18,1.71,15-21,25.38-19.37,6.53,1,8.91,13.1,14.41,22.69,3.25,5.67,7.6,10.47,14.56,11.53,6.33,1,10.56-.5,13.85-2.81,6.45-4.51,9.33-12.21,17.39-11,4.78.73,6.52,4.41,8.3,7.88,1.55,3,3.13,5.9,6.81,6.46,4.33.67,8-5.53,11.93-11,3.21-4.52,6.56-8.58,10.54-8s6.48,5.51,7.69,9A31.4,31.4,0,0,1,385.8,236.38Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,195.87l-10.72,70a1.75,1.75,0,0,1-2,1.47L121.61,227.89a1.75,1.75,0,0,1-1.46-2l.6-3.94c10.7,1.64,16.41-6.37,23.59-5.27s10.9,6.11,17.62,7.14,17.09-14.7,24.44-13.57a13.49,13.49,0,0,1,3.35.94c2.83,1.18,4.78,3.08,7.4,4.66a18,18,0,0,0,6.74,2.42c8.61,1.31,25.84-29.85,35.83-28.32a7.56,7.56,0,0,1,4.43,2.56c5.9,6.43,7.42,22.51,15.74,23.78,10.09,1.55,15.49-14.86,25.28-13.37s12.67,18.37,24,20.1,23.62-29.23,35.39-27.43,15.13,17.71,25.36,19.27C381.15,216.58,392,195.87,392,195.87Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,228.41l-5.74,37.45a1.75,1.75,0,0,1-2,1.47L121.61,227.89a1.75,1.75,0,0,1-1.46-2l.29-1.93c.37-.35,6.44-6.08,12.6-5.14,6.37,1,6.39,6.68,15.27,8s11.47-5.67,24.07-3.74,12.56,10.74,25.59,12.74,15.72-8.57,25-7.15,8.63,6.81,13.89,7.61,8.32-7.44,14.79-6.45,11.42,14.55,18.71,15.67c5.12.78,14.17-9.36,23.41-14.8,3.9-2.3,7.85-3.76,11.53-3.19,7.61,1.16,12.05,7.1,16.88,11.91,3,3,6.23,5.6,10.45,6.25,6,.92,10.61-4.54,15.24-9.34,3.76-3.91,7.55-7.39,12.16-6.69a18.78,18.78,0,0,1,6.58,2.12c4,2.24,5.05,5.26,9.83,6C382.19,238.67,387,228.41,387,228.41Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,126.26l-13.84-2.12a2.46,2.46,0,0,1-2.06-2.81h0a2.47,2.47,0,0,1,2.81-2.07l13.83,2.12a2.48,2.48,0,0,1,2.07,2.81h0A2.48,2.48,0,0,1,152.05,126.26Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.69,123.47h.22l13.84,2.12a1.49,1.49,0,0,1,1,.58,1.51,1.51,0,0,1,.27,1.09,1.49,1.49,0,0,1-1.45,1.25l-.23,0-13.83-2.12a1.43,1.43,0,0,1-1-.58,1.46,1.46,0,0,1,1.18-2.33m0-1a2.46,2.46,0,0,0-.37,4.9l13.83,2.12a2.43,2.43,0,0,0,.38,0,2.47,2.47,0,0,0,.37-4.91l-13.84-2.11a2.31,2.31,0,0,0-.37,0Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.79,126.7H181l13.83,2.12a1.47,1.47,0,0,1-.22,2.92l-.22,0-13.84-2.12a1.48,1.48,0,0,1-1-.58,1.45,1.45,0,0,1-.26-1.09,1.47,1.47,0,0,1,1.44-1.24m0-1a2.46,2.46,0,0,0-.37,4.9l13.84,2.12a2.31,2.31,0,0,0,.37,0,2.47,2.47,0,0,0,.37-4.91l-13.83-2.11a2.43,2.43,0,0,0-.38,0Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.26,161.41l.17-1.08-.8-.19a1.89,1.89,0,0,0-.13-.52l.62-.54-.64-.88-.71.43a2.27,2.27,0,0,0-.45-.28l.05-.82-1.08-.16-.19.8a2.11,2.11,0,0,0-.51.12l-.55-.62-.88.65.43.7a1.92,1.92,0,0,0-.27.46l-.82-.06-.17,1.08.8.2a1.82,1.82,0,0,0,.13.51l-.62.54.65.88.7-.43a2.6,2.6,0,0,0,.45.28l-.05.82,1.08.16.19-.79a3,3,0,0,0,.52-.13l.54.62.88-.65-.43-.7a2.07,2.07,0,0,0,.27-.45Zm-3.07.26a1.27,1.27,0,1,1,1.45-1.06A1.27,1.27,0,0,1,393.19,161.67Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.14,
    y: 280.06,
    width: 2.98,
    height: 21.4,
    transform: "translate(46.72 -32.6) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.51,
    y: 283.31,
    width: 2.98,
    height: 10.07,
    transform: "translate(46.36 -32.69) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.7,
    y: 284.38,
    width: 2.98,
    height: 21.4,
    transform: "translate(47.3 -31.43) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.15,
    y: 293.58,
    width: 10.08,
    height: 2.98,
    transform: "translate(-96.31 477.96) rotate(-81.3)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.69,
    y: 279.31,
    width: 2.98,
    height: 21.4,
    transform: "matrix(0.99, 0.15, -0.15, 0.99, 46.46, -30.58)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.33,
    y: 287.34,
    width: 2.98,
    height: 10.08,
    transform: "translate(46.81 -30.5) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.12,
    y: 285.25,
    width: 2.98,
    height: 21.4,
    transform: "translate(47.58 -33.45) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.49,
    y: 288.5,
    width: 2.98,
    height: 10.08,
    transform: "translate(47.23 -33.54) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.7,
    y: 280.01,
    width: 2.98,
    height: 21.4,
    transform: "translate(46.87 -34.66) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.19,
    y: 282.46,
    width: 2.98,
    height: 10.08,
    transform: "translate(46.39 -34.77) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.49,
    y: 286.48,
    width: 2.98,
    height: 21.4,
    transform: "translate(47.92 -35.46) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.22,
    y: 287.34,
    width: 2.98,
    height: 10.08,
    transform: "translate(47.2 -35.62) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.8,
    y: 276.43,
    width: 2.98,
    height: 21.4,
    transform: "translate(46.49 -36.83) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.54,
    y: 277.3,
    width: 2.98,
    height: 10.07,
    transform: "translate(45.78 -37) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.38,
    y: 290.77,
    width: 2.98,
    height: 21.4,
    transform: "translate(48.72 -37.36) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.75,
    y: 294.02,
    width: 2.98,
    height: 10.08,
    transform: "translate(48.36 -37.44) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.82,
    y: 293.02,
    width: 2.98,
    height: 21.4,
    transform: "translate(49.13 -38.31) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.45,
    y: 301.05,
    width: 2.98,
    height: 10.08,
    transform: "translate(49.49 -38.22) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.47,
    y: 280.75,
    width: 2.98,
    height: 21.4,
    transform: "translate(47.39 -39.77) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.99,
    y: 289.58,
    width: 2.98,
    height: 10.07,
    transform: "translate(47.85 -39.65) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.67,
    y: 291.07,
    width: 2.98,
    height: 21.4,
    transform: "translate(49 -40.43) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.92,
    y: 295.12,
    width: 2.98,
    height: 10.07,
    transform: "translate(48.75 -40.48) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.14,
    y: 286.56,
    width: 2.98,
    height: 21.4,
    transform: "translate(48.4 -41.61) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.51,
    y: 289.81,
    width: 2.98,
    height: 10.08,
    transform: "matrix(0.99, 0.15, -0.15, 0.99, 48.04, -41.69)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.22,
    y: 278.07,
    width: 2.98,
    height: 21.4,
    transform: "translate(47.21 -42.93) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.07,
    y: 278.14,
    width: 2.98,
    height: 10.08,
    transform: "translate(46.37 -43.12) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.79,
    y: 292.49,
    width: 2.98,
    height: 21.4,
    transform: "translate(49.45 -43.46) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.28,
    y: 294.94,
    width: 2.98,
    height: 10.08,
    transform: "translate(48.96 -43.56) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.99,
    y: 302.8,
    width: 2.98,
    height: 21.4,
    transform: "translate(51.06 -44.12) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.48,
    y: 305.25,
    width: 2.98,
    height: 10.08,
    transform: "translate(50.58 -44.23) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.32,
    y: 292.62,
    width: 2.98,
    height: 21.4,
    transform: "translate(49.62 -45.5) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.96,
    y: 300.65,
    width: 2.98,
    height: 10.08,
    transform: "translate(49.98 -45.43) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.78,
    y: 281.67,
    width: 2.98,
    height: 21.4,
    transform: "translate(48.06 -46.9) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.17,
    y: 291.3,
    width: 2.98,
    height: 10.08,
    transform: "translate(48.65 -46.77) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.57,
    y: 294.64,
    width: 2.98,
    height: 21.4,
    transform: "translate(50.08 -47.48) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.94,
    y: 297.89,
    width: 2.98,
    height: 10.08,
    transform: "matrix(0.99, 0.15, -0.15, 0.99, 49.73, -47.57)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.65,
    y: 299.18,
    width: 2.98,
    height: 21.4,
    transform: "translate(50.83 -48.35) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.17,
    y: 308.01,
    width: 2.98,
    height: 10.08,
    transform: "translate(51.31 -48.24) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.28,
    y: 293.59,
    width: 2.98,
    height: 21.4,
    transform: "translate(50.08 -49.57) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.14,
    y: 293.66,
    width: 2.98,
    height: 10.08,
    transform: "translate(49.24 -49.76) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.9,
    y: 301.2,
    width: 2.98,
    height: 21.4,
    transform: "translate(51.29 -50.33) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.51,
    y: 302.86,
    width: 2.98,
    height: 10.08,
    transform: "translate(50.69 -50.47) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.96,
    y: 299.36,
    width: 2.98,
    height: 21.4,
    transform: "translate(51.1 -51.42) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.69,
    y: 300.22,
    width: 2.98,
    height: 10.08,
    transform: "translate(50.38 -51.58) rotate(8.7)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.16,
    y: 303.09,
    width: 2.98,
    height: 21.4,
    transform: "translate(51.73 -52.31) rotate(8.7)",
    style: {
      fill: "#10A7D0",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.43,
    y: 313.52,
    width: 2.98,
    height: 10.08,
    transform: "matrix(0.99, 0.15, -0.15, 0.99, 52.46, -52.16)",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.86,
    y: 328.57,
    width: 56.12,
    height: 1.74,
    transform: "translate(52.58 -32.21) rotate(8.7)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.06,211.88s-7.52,4.17-2.73,15.47,33.92,29.88,33.33,39.32c0,0-29.91-18.64-38.22-7.88,0,0,22.59,21.91,24.94,38.39s10,23.79,27.68,33.19,56.12,59,56.12,59l-5.75-83.3-56-63.2-27.68-15.78Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,360.4,403.7,392.78l-.08,0a.24.24,0,0,1-.21-.15c-.22-.58-22-58.79-27.25-63.33a21.45,21.45,0,0,1-6.22-9.94v0s0-.05,0-.08c-.19-.64-.28-1.06-.3-1.17a36.25,36.25,0,0,0-12.87-14.46,67.18,67.18,0,0,0-11.64-5.6c-6.2-2.51-12.58-5.1-17.09-9.89a21,21,0,0,1-2.11-2.63c-7.17-10.5-18.24-22.09-21.93-24.47S293.52,259,293.46,259a.22.22,0,0,1-.24-.18,6.29,6.29,0,0,1,1.62-5.09,10,10,0,0,1,7.63-3.5c5.7,0,13.55,3,17.51,6.77s13.12,6.54,14.17,6.86c1.49-.88,5,1,6.29,1.81-1.53-5.45-.91-7.55-.67-8.08-3.28-4.25-20.36-16.83-29.43-23.14h0c-2.5-1.75-4.38-3-5.2-3.49-4.23-2.49-7.73-10.28-7.05-15.72a5,5,0,0,1,2-3.78,4.82,4.82,0,0,1,2.85-.73,6.26,6.26,0,0,1,1.21.15.41.41,0,0,1,.11.07c.08.11,8.57,10.18,11.51,11.76,1.44.77,9.1,4.64,16.38,8.24l3.28,1.62a80.69,80.69,0,0,1,.5-9.49c.28-1.24,2.26-3,4.51-4,1.05-.48,3-1.17,4.43-.41.55.31,1.85,1.11,3.65,2.23l3,1.86a11.68,11.68,0,0,1,2.32-2.61c.75-.44,4.9-1.21,6.38-.69,1.29.47,5.43,3.1,9.81,5.88l1.89,1.19c.23-.43.77-1.33,1.28-1.53a11.42,11.42,0,0,1,6.75-.36c1.48.54,6.56,4.29,11.48,7.92,2.7,2,5.29,3.91,7,5.06a.24.24,0,0,1,.14.1c.49.33.9.59,1.21.77,3.62,2.07,12.52,48.75,12.61,49.22.58,3.13,2.7,6.36,4.94,9.78A51.71,51.71,0,0,1,423.5,309c2.85,8.33,9.34,20.52,18.85,35.42q1.29,2,2.66,4.11C447.58,352.42,450.32,356.48,453,360.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.14,271c-1.91,1.51-15.77.08-17.47,4.74-1,2.75-.26,6.91,2.34,12.4a21,21,0,0,1-2.11-2.63c-7.17-10.5-18.24-22.09-21.93-24.47S293.52,259,293.46,259a.22.22,0,0,1-.24-.18,6.29,6.29,0,0,1,1.62-5.09,10,10,0,0,1,7.63-3.5c5.7,0,13.55,3,17.51,6.77s13.12,6.54,14.17,6.86c1.49-.88,5,1,6.29,1.81-1.53-5.45-.91-7.55-.67-8.08-3.28-4.25-20.36-16.83-29.43-23.14h0c-2.5-1.75-4.38-3-5.2-3.49-4.23-2.49-7.73-10.28-7.05-15.72a5,5,0,0,1,2-3.78,4.82,4.82,0,0,1,2.85-.73,6.4,6.4,0,0,0-1.88,1.14c-2.78,2.37,3.85,14.88,7.58,18.34,3.9,3.61,21.44,12.57,27.74,17.91,3.46,2.93,8,7.37,8,7.37C341.61,260.21,345,269.52,343.14,271Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.54,194.53c0-.09,0-.11,0-.07A.06.06,0,0,1,407.54,194.53Z",
    style: {
      fill: "#10A7D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.35,344.37c-7.43-7.07-18.49-18.08-20.56-22.91-3.16-7.4-5.27-14.23-9.2-19.21s-11.9-58.05-14.19-58.2,2.88,21,3.15,22.08c-.22-.67-3.08-9.68-5.82-19.95-2.84-10.67-5.71-11.25-5.71-11.25-3.81.76-3.83,3.47-5.78,3.43s-8.64-4.79-8.64-4.79c-6.49.94-30.84-14.74-30.84-14.74-5.54.75-6.84,5.59-2.11,10.13S354.45,239,354.45,239c-4.56,2.22-21.3-7.17-21.3-7.17l-1-.9,3.28,1.62a80.69,80.69,0,0,1,.5-9.49c.28-1.24,2.26-3,4.51-4,1.05-.48,3-1.17,4.43-.41.55.31,1.85,1.11,3.65,2.23l3,1.86a11.68,11.68,0,0,1,2.32-2.61c.75-.44,4.9-1.21,6.38-.69,1.29.47,5.43,3.1,9.81,5.88l1.89,1.19c.23-.43.77-1.33,1.28-1.53a11.42,11.42,0,0,1,6.75-.36c1.48.54,6.56,4.29,11.48,7.92,2.7,2,5.29,3.91,7,5.06a.24.24,0,0,1,.14.1c.49.33.9.59,1.21.77,3.62,2.07,12.52,48.75,12.61,49.22.58,3.13,2.7,6.36,4.94,9.78A51.71,51.71,0,0,1,423.5,309C426.35,317.28,432.84,329.47,442.35,344.37Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.62,392.58s-22-58.8-27.31-63.42A21.17,21.17,0,0,1,369.83,318a36.32,36.32,0,0,0-13-14.58c-9.49-6.25-23.84-7.87-30.78-18s-18.06-22-22-24.54-10.65-2.08-10.65-2.08c-.69-3.94,3.7-8.33,9-8.33s13.19,2.77,17.36,6.71,14.35,6.94,14.35,6.94c1.62-1.16,6.63,2.06,6.63,2.06-2-6.77-.79-8.6-.79-8.6-3.93-5.32-30.84-24.47-34.77-26.79s-7.64-9.95-6.95-15.51a4.47,4.47,0,0,1,5.79-4.16s8.56,10.18,11.57,11.8,26.62,13.43,30.09,14.81a6.52,6.52,0,0,0,6-.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.65,232.93s0-7.7.5-9.79,6.07-5.69,8.61-4.31,21.3,13.72,26.19,14.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.59,223a13.22,13.22,0,0,1,2.38-2.73c.69-.41,4.8-1.17,6.19-.67,2.78,1,19.16,12.3,21.93,13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,226.82s.71-1.42,1.28-1.65a11.09,11.09,0,0,1,6.59-.35c2.55.93,16.55,12,19.79,13.83s11.35,42.82,12.5,49.07,8.11,12.5,11.11,21.3,10.19,22.22,21.53,39.58c2,3,4.08,6.17,6.17,9.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.92,249.24s1-4.69,3.82-6.77,6.6,1.22,9.37,1.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.84,241.78s1.56-5.39,4.34-6.6,7.06,2.43,8.91,2.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07,236.91s2.08-2,2.95-2,4.51,3.81,5.3,4.07,1.73-1.17,3.08-1.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.74,232a7.17,7.17,0,0,1,4.33,1.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,257.57s-1.38-3.56-.69-5.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.71,231.45s1.65,1.93,1.74,3.48,4,3.43,4,3.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.18,232.63s2.27-.81,3.48,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,262.26a7,7,0,0,1,2.69-6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.81,266.17s-2.58,2.22-2.58,3.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.93,262.26c3.06,1.14,5.6,5.9,7.45,6.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,247.1c1.85,2.66,6,22,10.18,28.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,241.64c.35.23,2.78,7.75,2.78,7.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.59,289.29a44.7,44.7,0,0,0,3.3,11.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.14,319.31c-.31-1.27-1.65-9.6-3.3-12.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.89,449.29s32.54-43.75,57.08-51.76,25.75-18.88,24.75-39.16-.26-40.72-7-43.16,8.08-28.92,1-39.41l-46.43,72.94Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,461.48l-.49-.16.7.39Zm79.1-134.21c-4-1.87-11.94-10.64-12.93-11.74,5-8.42,9.94-16.54,11.65-18.49,3.55-4,7.88-15.67,6.12-21.31-1.61-5.18-6.88-4.35-7.6-4.21l-.08,0a.18.18,0,0,0-.13.09c-.11.19-10.84,18.28-14.17,22.61-1.59,2.06-5.25,6.75-9,11.45l-1.11-.17a19.24,19.24,0,0,0-7,.2l-.23.08a24.15,24.15,0,0,0-3.43,1.82l-.79-.33c-1.58-.66-4.85-1.93-6.4-2-1.89-.1-8.55,3-12.53,5.5A26.84,26.84,0,0,0,95,309.62c-3.05.13-9.27,2.66-14.27,4.69-2.22.9-4.14,1.68-5.26,2l-1,.3c-3,.89-4.62,1.39-6.7,5.55-2.16,4.32-4.49,20.43-5.61,28.17l-.15,1.05c-.43,3-.36,8.26-.29,13.87.11,7.8.22,15.86-.94,19a49.51,49.51,0,0,1-6.16,11.12c-.33.47-.63.91-.91,1.33a34.29,34.29,0,0,0-3.71,7.81c-.84,2.22-1.89,4.66-2.91,6.89-1.88,4.13-3.63,7.54-3.63,7.54S78.91,458.05,82,461.48a4.26,4.26,0,0,0,.51.16c.12-.2,6.66-11.38,13.59-22.41,6-9.52,12.23-18.93,14.9-21.09a24.73,24.73,0,0,0,7.66-11.92c1.44-4.63,10.63-10.34,19.52-15.86,9.83-6.1,20-12.41,20.34-17.63.19-2.7.81-7.17,1.53-12.36C162,346.31,164.42,328.8,161.1,327.27Zm-16.84,22.48L139.89,354c-.62-3.5-4.87-8.15-5.54-8.86a36.59,36.59,0,0,0,.65-5.1c.16-1.95.33-4,.81-4.33s2.69-4,6.29-10c.3,4.23,4,8.89,4.5,9.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.37,336.76c-1.29,11.52-12.58,40.1-12.58,40.1l-2-28.79S69,387.14,66.59,388.55s-6.64,8.88-9,14.81c-1.59,4-7,6.72-10.41,8.09,1-2.23,2.07-4.67,2.91-6.89a34.29,34.29,0,0,1,3.71-7.81c.28-.42.58-.86.91-1.33a49.51,49.51,0,0,0,6.16-11.12c1.16-3.16,1-11.22.94-19-.07-5.61-.14-10.91.29-13.87l.15-1.05c1.12-7.74,3.45-23.85,5.61-28.17,2.08-4.16,3.72-4.66,6.7-5.55l1-.3c1.12-.35,3-1.13,5.26-2,5-2,11.22-4.56,14.27-4.69a26.84,26.84,0,0,1,8.42,1.17c4-2.51,10.64-5.6,12.53-5.5,1.55.07,4.82,1.34,6.4,2C115.8,310.76,104.63,319,104.63,319,92,321.74,92.37,336.76,92.37,336.76Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75,321.46a111.3,111.3,0,0,1,10.15-6.25c3.24-1.52,4.28-7.58,2-9.29a.64.64,0,0,0-.29-.12l.23-.08a19.24,19.24,0,0,1,7-.2c-4.19,6.29-7.47,11.11-8.34,12.15C122.62,321.17,114.75,321.46,114.75,321.46Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.28,360.93l1.53.66C131.88,365.3,131.28,360.93,131.28,360.93Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.1,327.27c-4-1.87-11.94-10.64-12.93-11.74,5-8.42,9.94-16.54,11.65-18.49,3.55-4,7.88-15.67,6.12-21.31-1.61-5.18-6.88-4.35-7.6-4.21l0,.22s5.7.71,5.69,8.95-14.81,24.57-14.81,24.57S134,333.81,133,333.38s-3.23,19.08-3.23,19.08,4.24,3.61,3.23,8.47q-.08.36-.15.66l6.52,2.81s6.54-4.59,9.86,2.16S117.31,397.43,114.54,401c0,0-.39,13.45-5.53,15.43-3.33,1.28-9.2,14-12.91,22.81,6-9.52,12.23-18.93,14.9-21.09a24.73,24.73,0,0,0,7.66-11.92c1.44-4.63,10.63-10.34,19.52-15.86,9.83-6.1,20-12.41,20.34-17.63.19-2.7.81-7.17,1.53-12.36C162,346.31,164.42,328.8,161.1,327.27Zm-16.84,22.48L139.89,354c-.62-3.5-4.87-8.15-5.54-8.86a36.59,36.59,0,0,0,.65-5.1c.16-1.95.33-4,.81-4.33s2.69-4,6.29-10c.3,4.23,4,8.89,4.5,9.56Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,321.72a13.49,13.49,0,0,0,7.09-4.05c3-3.37,15.2-18.91,18.58-23.3s14.18-22.63,14.18-22.63,5.74-1.35,7.43,4.06-2.36,16.88-6.08,21.1-22.63,37.66-24,38.67-.33,10.48-3,12.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.11,345.23s5.29,5.54,5.63,9.25l4.72-4.62,2.37-14.63s-4.67-5.62-4.53-10.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.91,315.56s8.71,9.88,13.1,11.91-2,35.46-2.7,45.25-36.81,23.62-39.85,33.43a24.35,24.35,0,0,1-7.6,11.82c-5.86,4.75-28.54,43.57-28.54,43.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.09,305.92s-5.15-.95-8.19,0S111,316,108,317.67s-7.43,2-8.44,4.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2,307.86S118,305.6,116,305.5s-10.13,3.73-13.84,6.43a29.66,29.66,0,0,1-9.46,4.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.48,311a26.29,26.29,0,0,0-8.43-1.19c-4.4.19-15.88,5.59-19.48,6.72s-5.29,1.23-7.54,5.74-4.73,22.17-5.74,29.15.79,27.41-1.24,32.93S55.89,394,54,396.87c-3.85,5.72-3.42,10-10.43,22.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.33,323.24c-4.39,3.89-3.58,11.32-3,13.52s-2.11,11-3,15.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2,327c-8,.17-10.48,5.57-11,9.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.42,319c-2.37-.17-8.45,3.55-9.63,9.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.83,335.23s1.18-3.37,2.36-3.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,349.86a43.87,43.87,0,0,1-2.16,5.8c-1,2,0,5.19,0,5.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.74,354.48c-.17,3.38-3.89,7-4.65,6.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.94,348.74c-.12,3.72-6.87,30.9-6.87,30.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.b6685609c356bcfd8172cfd7fc8d4491.svg";
export { ForwardRef as ReactComponent };